export default __webpack_public_path__ + "static/app-logbook-897dd549ab283e63c0f5efe2c7a7ad41.png";